module.exports = __webpack_public_path__ + "img/m-wash3prousa_5-menu-desktop.b8d38295.png";